// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"502":"6c19ada2","505":"2a83d3dd"}[chunkId] + ".chunk.js";
};